import { useService } from '@policoders/di';
import { useEffect, useState } from 'react';

import { MeasureUnitType } from '../../../types/measure-unit.type';
import { Product } from './product.model';
import ProductRepository from './product.repository';

export type IProductFormProps = {
  data: Product;
  onChange: (data: Product) => void;
};

export const useProductForm = ({ data, onChange }: IProductFormProps) => {
  const [state, setState] = useState<Product>(data);
  const repository = useService<ProductRepository>('ProductRepository');

  useEffect(() => {
    data.id &&
      repository.getById(data.id).then(value => {
        setState({ ...data, ...value });
      });
  }, [data, repository]);

  useEffect(() => {
    onChange && onChange(state);
  }, [onChange, state]);

  const handleChange = (e: any) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const measureUnitTypes = () => {
    var items = Object.keys(MeasureUnitType);
    var values = Object.values(MeasureUnitType);
    return [
      ...items.map((item, i) => ({
        label: item.replace('_', ' '),
        value: values[i],
      })),
    ];
  };

  return { state, measureUnitTypes, handleChange };
};
